/**
 * 时段热点
 * 2019-03-28
 * Yin.Qingdong
 */
"use strict";
angular.module('timeHotSpotsModule', ['timeHotSpotsTimeLineModule', 'timeSlotSelectModule', 'relateManuscriptsModule'])
    .controller('timeHotSpotsCtrl', ["$scope", "$filter", "$sce", "$timeout", "$state", "modalDialog", "trsspliceString", "trsHttpService", "hotFocusService",
        function($scope, $filter, $sce, $timeout, $state, modalDialog, trsspliceString, trsHttpService, hotFocusService) {

            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    startTime: '', // 开始时间段
                    endTime: '', // 结束时间段
                    curTime: '', // 当前时间
                    curHour: '', // 当前小时
                    selectTitletab: '',
                    curManuscript: null, // 当前稿件
                    params: {
                        starttime: '',
                        endtime: ''
                    } 
                };
                $scope.data = {
                    ranklistLists: [],
                    hotSpotsDetail: {}, // 热点详情   
                    relateManuList:[], // 相关稿件
                };
                $scope.page = {
                    "STARTPAGE": 1,
                    "PAGESIZE": 10
                };
                $scope.relateListPage = {
                    pageno: '1',
                    pagesize: '20'
                }
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getTtitletab();
                reqTableData();
            }

            /*
             * [timeHotSpotsLine description]请求热点汇总时间轴
             */
            function reqTimeLineData() {
                $scope.status.params.starttime = $scope.status.startTime ? $scope.status.startTime.name : $scope.status.startTime;
                $scope.status.params.endtime = $scope.status.endTime ? $scope.status.endTime.name : $scope.status.endTime;
                var params = {
                    typeid: "widget",
                    serviceid: "periodhotpoint",
                    modelid: "pushtimeline",
                    starttime: $scope.status.params.starttime,
                    endTime: $scope.status.params.endtime
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.STATUS && data.STATUS == 'success') {
                        $scope.data.timeLineList = data.CONTENT;
                        if (Object.keys($scope.data.timeLineList).length > 0) {
                            $scope.status.curManuscript = get_object_first_attribute($scope.data.timeLineList);
                            reqManuscriptDetail(); // 稿件详情
                            reqRelevantManuData(); // 相关稿件
                        }
                    }
                });
            }

            /**
             * [get_object_first_attribute description]获取对象第一个key值
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function get_object_first_attribute(data) {
                for (var key in data) {
                    return data[key][0];
                }
            }
            /**
             * [reqTableData description]请求列表数据
             * @return {[type]} [description]
             */
            function reqTableData() {
                $scope.status.params.starttime = $scope.status.startTime ? $scope.status.startTime.name : $scope.status.startTime;
                $scope.status.params.endtime = $scope.status.endTime ? $scope.status.endTime.name : $scope.status.endTime;
                var params = {
                    typeid: "widget",
                    serviceid: "periodhotpoint",
                    modelid: "pointlist",
                    pageno: $scope.page.STARTPAGE,
                    pagesize: $scope.page.PAGESIZE,
                    starttime: $scope.status.params.starttime,
                    endtime: $scope.status.params.endtime
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.STATUS && data.STATUS == 'success') {
                        data.CONTENTS.forEach(function(item, index) {
                            item.sitename = item.sitename.replace(/客户端/, '');
                        })
                        $scope.data.ranklistLists = data.CONTENTS;
                        $scope.status.curManuscript = $scope.data.ranklistLists.length > 0 ? $scope.data.ranklistLists[0] : '';
                        $scope.page = {
                            STARTPAGE: data.PAGENO,
                            PAGESIZE: data.PAGESIZE,
                            ITEMCOUNT: data.TOTALNUM,
                            PAGECOUNT: data.TOTALPAGES
                        };
                        $scope.status.curTime = data.SHOWTIME;
                        $scope.status.curHour = data.TIMECONTROLVALUE;
                        if ($scope.data.ranklistLists.length > 0) {
                            reqManuscriptDetail(); // 稿件详情
                            reqAppPulishTimeLine(); // 客户端发版
                            reqRelevantManuData(); // 相关稿件
                        }
                    }
                });
            }
            /**
             * [getTtitletab description]获取一级标签
             * 
             */
            function getTtitletab() {
                $scope.status.hotSpotsTitle = [{ value: 0, name: '总热度值' }, { value: 1, name: '时间轴' }];
                $scope.status.selectTitletab = $scope.status.hotSpotsTitle[0].value;
            }

            $scope.clickTitletab = function(title) {
                if ($scope.status.selectTitletab == title.value) { return };
                $scope.status.selectTitletab = title.value;

                if ($scope.status.selectTitletab == 0) {
                    $scope.page.STARTPAGE = 1;
                    reqTableData();
                }
                if ($scope.status.selectTitletab == 1) {
                    reqTimeLineData();
                }
            };

            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                reqTableData();
            };

            /** [makeFastNews description]制作快讯*/
            $scope.makeFastNews = function() {
                if (!nextValidate() || !$scope.status.curManuscript) {
                    return;
                }
                var item = {};
                item = angular.copy($scope.status.curManuscript);
                item.starttime = $scope.status.params.starttime;
                item.endtime = $scope.status.params.endtime;
                item.curTime = $scope.status.curTime;
                hotFocusService.makeFastNews(item);
            };

            /**
             * [searchData description]搜索
             * @return {[type]} [description]
             */
            $scope.searchData = function() {
                if (!nextValidate()) {
                    return;
                }
                if ($scope.status.selectTitletab == 0) {
                    reqTableData();
                } else {
                    reqTimeLineData();
                }

            }

            /**
             * [nextValidate description]校验
             * @return {[type]} [description]
             */
            function nextValidate() {
                if ($scope.status.startTime == '' && $scope.status.endTime != '') {
                    modalDialog.alertType("请选择开始时间", "", "warning", false);
                    return false;
                } else if ($scope.status.startTime != '' && $scope.status.endTime == '') {
                    modalDialog.alertType("请选择结束时间", "", "warning", false);
                    return false;
                } else {
                    return true;
                }
            }

            /**
             * [clickTableList description]点击table稿件标题
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.clickTableList = function(item) {
                $scope.status.curManuscript = item;
                reqManuscriptDetail(); // 稿件详情
                reqAppPulishTimeLine(); // 客户端发版
                reqRelevantManuData(); // 相关稿件
            }

            /**
             * [reqManuscriptDetail description]稿件详情
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function reqManuscriptDetail(data) {
                $scope.data.hotSpotsDetail = $scope.status.curManuscript;
                // var params = {
                //     typeid: "widget",
                //     serviceid: "periodhotpoint",
                //     modelid: "pointDetail",
                //     guid: data ? data.docGuids : $scope.status.curManuscript.mainGuid
                // };
                // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                //     if (data.STATUS && data.STATUS == 'success') {
                //         $scope.data.hotSpotsDetail = data.CONTENTS[0];
                //     }
                // });
            }

            /**
             * [reqAppPulishTimeLine description]客户端发布时间轴
             * @return {[type]} [description]
             */
            function reqAppPulishTimeLine(data) {
                var params = {
                    typeid: "widget",
                    serviceid: "periodhotpoint",
                    modelid: "pushtimeline",
                    guids: data ? data.docGuids : $scope.status.curManuscript.docGuids
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.STATUS && data.STATUS == 'success') {
                        $scope.data.timeAppLineList = data.CONTENT;
                    }
                });
            }

            /**
             * [lineCallback description]时间轴回调
             * @return {[type]} [description]
             */
            $scope.lineCallback = function() {
                reqManuscriptDetail(); // 稿件详情
                reqRelevantManuData(); // 相关稿件
            }

            /*
             * [reqRelevantManuData description]请求相关稿件
             */
            function reqRelevantManuData() {
                var params = {
                    typeid: "widget",
                    serviceid: "periodhotpoint",
                    modelid: "relevantDocs",
                    pageno: $scope.relateListPage.pageno,
                    pagesize: $scope.relateListPage.pagesize,
                    keywords: $scope.status.curManuscript.keywords,
                    guid: $scope.status.curManuscript.mainGuid,
                    sitename: $scope.status.curManuscript.sitename
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.STATUS && data.STATUS == 'success') {
                        $scope.data.relateManuList = data.CONTENTS;
                        $scope.relateListPage = {
                            pageno: data.PAGENO,
                            pagesize: data.PAGESIZE,
                            totalnum: data.TOTALNUM,
                            totalpages: data.TOTALPAGES
                        };
                        if ($scope.data.relateManuList.length <= 0) { // 如果长度为0，pageno重置为1
                            $scope.relateListPage.pageno = '1';
                        }
                    }
                });
            }

            /**
             * [relateManuCallback description]相关稿件list回调
             * @return {[type]} [description]
             */
            $scope.relateManuCallback= function() {
                reqRelevantManuData();
            }
        }
    ]);